/* eslint-disable import/no-anonymous-default-export */
import axios from "core/axios";


export default {
  useBonus: () => {
    return axios.put(`/payment/claimFillProfileGift`, {}, {
      headers: {
        Authorization: `Bearer ${window.localStorage.accessToken}`,
      },
    })
  }
};
